import type { MutableRefObject } from 'react';
import { createContext } from 'react';

export type TBlogContext = {
    headingsRef?: MutableRefObject<string[]>;
};

export const BlogContext = createContext<TBlogContext>({});
